/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../../api/types.generated";
export type CreateVolunteerShiftMutationVariables = Types.Exact<{
  category_name: Types.Scalars["String"];
  organizer_responsible_user_id: Types.Scalars["Float"];
  name: Types.Scalars["String"];
  start_time: Types.Scalars["DateTimeISO"];
  end_time: Types.Scalars["DateTimeISO"];
  max_count: Types.Scalars["Float"];
  preferred_min_signups: Types.Scalars["Float"];
  location?: Types.Maybe<Types.Scalars["String"]>;
  event_id: Types.Scalars["Float"];
  description: Types.Scalars["String"];
}>;

export type CreateVolunteerShiftMutation = {
  createVolunteerShift: Pick<
    Types.VolunteerShift,
    | "shift_id"
    | "category_name"
    | "organizer_responsible_user_id"
    | "preferred_min_signups"
    | "createdAt"
  > & {
    category: Pick<Types.VolunteerCategory, "name" | "primary_only">;
    shift: Pick<
      Types.EventActivity,
      | "category"
      | "created_at"
      | "end_time"
      | "event_id"
      | "id"
      | "location"
      | "name"
      | "restrictions"
      | "start_time"
      | "updated_at"
      | "slug"
      | "restrictions_string"
    >;
  };
};

export const CreateVolunteerShiftDocument = gql`
  mutation CreateVolunteerShift(
    $category_name: String!
    $organizer_responsible_user_id: Float!
    $name: String!
    $start_time: DateTimeISO!
    $end_time: DateTimeISO!
    $max_count: Float!
    $preferred_min_signups: Float!
    $location: String
    $event_id: Float!
    $description: String!
  ) {
    createVolunteerShift(
      data: {
        category_name: $category_name
        organizer_responsible_user_id: $organizer_responsible_user_id
        name: $name
        start_time: $start_time
        end_time: $end_time
        max_count: $max_count
        preferred_min_signups: $preferred_min_signups
        location: $location
        event_id: $event_id
        description: $description
      }
    ) {
      shift_id
      category_name
      organizer_responsible_user_id
      preferred_min_signups
      createdAt
      category {
        name
        primary_only
      }
      shift {
        category
        created_at
        end_time
        event_id
        id
        location
        name
        restrictions
        start_time
        updated_at
        slug
        restrictions_string
      }
    }
  }
`;

/**
 * __useCreateVolunteerShiftMutation__
 *
 * To run a mutation, you first call `useCreateVolunteerShiftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVolunteerShiftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVolunteerShiftMutation, { data, loading, error }] = useCreateVolunteerShiftMutation({
 *   variables: {
 *      category_name: // value for 'category_name'
 *      organizer_responsible_user_id: // value for 'organizer_responsible_user_id'
 *      name: // value for 'name'
 *      start_time: // value for 'start_time'
 *      end_time: // value for 'end_time'
 *      max_count: // value for 'max_count'
 *      preferred_min_signups: // value for 'preferred_min_signups'
 *      location: // value for 'location'
 *      event_id: // value for 'event_id'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useCreateVolunteerShiftMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CreateVolunteerShiftMutation,
    CreateVolunteerShiftMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    CreateVolunteerShiftMutation,
    CreateVolunteerShiftMutationVariables
  >(CreateVolunteerShiftDocument, baseOptions);
}
export type CreateVolunteerShiftMutationHookResult = ReturnType<
  typeof useCreateVolunteerShiftMutation
>;
export type CreateVolunteerShiftMutationResult =
  ApolloReactCommon.MutationResult<CreateVolunteerShiftMutation>;
export type CreateVolunteerShiftMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    CreateVolunteerShiftMutation,
    CreateVolunteerShiftMutationVariables
  >;
